import ApplicationLayout from 'components/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import SignUpForm from 'components/SignUpForm';
import LoginSignupLayout from 'components/LoginSignupLayout';
import { Context } from 'types/Context';

type Props = {
  context: Context;
  redirectTo: string;
  mapTagging?: {
    invitedByUserFirstName: string;
  };
};

export default function SignUp({ context, redirectTo, mapTagging }: Props) {
  return (
    <CustomProvider>
      <ApplicationLayout context={context}>
        <LoginSignupLayout showBranchInterstitial={!redirectTo.includes('/plus/checkout')} redirectTo={redirectTo}>
          <SignUpForm redirectTo={redirectTo} mapTagging={mapTagging} />
        </LoginSignupLayout>
      </ApplicationLayout>
    </CustomProvider>
  );
}
